import { Button, Fade, IconButton, Typography, createTheme } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import printJS from 'print-js';
import moment from 'moment';
import { useEffect, forwardRef, useImperativeHandle } from 'react';
import { Modal } from './Modal';
import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/styles';
import { axiosInstanceForLambda } from '../../library/Axios';
import { getInvoiceMaster, getPartyAddressEntity } from '../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import { showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../redux/reducers/eInvReducer';
import API_ENDPOINTS from '../../apiEndpoints';
import { VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';

const PreviewSalesTaxable = forwardRef(
  (
    {
      open,
      setOpen,
      id,
      eImp,
      eWayImp,
      resetItems,
      taxability,
      resetNonItems,
      setInvData,
      setItems,
      setItemValid,
      setNonItemValid,
      setItemsRows,
      setNonItems,
      getLastSalesInvoice,
      resetData,
      getHtml,
      setEImp,
      setInvID,
      getInvoice,
      invoiceID,
      share,
      path,
      setBackdropOpen,
      allsalesfn,
      type = '',
    },
    ref
  ) => {
    const [data, setData] = useState();
    const [billing, setBilling] = useState();
    const [invoiceData, setInvoiceData] = useState();
    const [lineData, setLineData] = useState();
    const [iErr, setIErr] = useState('');
    const location = useLocation();
    const loc = location.pathname;
    const [saveNew, setSaveNew] = useState(false);
    const style = {
      width: '100%',
      // overflow: 'scroll',
    };
    const [html, sethtml] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [createPdf] = useCreatePdfMutation();
    let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
    let prev = useSelector((state) => state.eInvReducer);
    let prevData = useSelector((state) => state.eInvReducer.data);
    async function getInvoiceMasterData(id, save) {
      setSaveNew(save);
      try {
        const [invoiceData, billing] = await Promise.all([
          API.graphql(graphqlOperation(getInvoiceMaster, { invoiceid: id })),
          API.graphql(
            graphqlOperation(getPartyAddressEntity, {
              objectid: id,
              objecttype: 'SalesBilling',
            })
          ),
          // API.graphql(
          //   graphqlOperation(getPartyAddressEntity, {
          //     objectid: id,
          //     objecttype: 'SalesDelivery',
          //   })
          // ),
        ]);
        setInvoiceData(invoiceData.data.getInvoiceMaster[0]);
        const invAndNonInv = [
          ...invoiceData.data.getInvoiceMaster[0]?.relatedinvoicelineitems,
          ...invoiceData.data.getInvoiceMaster[0]?.relatedinvoicelinenonitems,
        ];
        setLineData(invAndNonInv);
        setBilling(billing.data.getPartyAddressEntity[0]);
        if (invoiceData.data.getInvoiceMaster !== null) {
          setData(invoiceData.data.getInvoiceMaster);
        }
        return true;
      } catch (error) {
        setBackdropOpen(false);
        console.log('error', error);
      }
    }
    useEffect(() => {
      if (open) {
        const test = getInvoiceMasterData(id);

        dispatch(einvId(false));
        Promise.all([getHtml(true)]).then((res) => {
          console.log(res, 'resmmm');
          sethtml(res[0]);
        });
        // setBackdropOpen(false);
      }

      return () => {};
    }, [open]);
    useEffect(() => {
      if (eImp === true || loc === '/salesInvoiceReport') {
        setBackdropOpen(true);
        generateEInv(invoiceData?.invoiceid);
        setBackdropOpen(false);
      }
    }, [invoiceData]);
    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        if (prev.preview === true) {
          navigate('/salesInvoiceReport');
        }
        setOpen(false);
      }
    };
    if (iErr === 'Incorrect Password' || iErr === 'Invalid login credentials') {
      setOpen(false);
      dispatch(einvAuth(true));
      setIErr('');
    }
    const invDat =
      lineData &&
      lineData.length > 0 &&
      lineData.map((itm, i) => {
        const gst = invoiceData.companystate === invoiceData.placeofsupply ? 'c' : 'i';
        const gstAmt = Number(itm.gstamount.toFixed(2));
        const gstRate =
          invoiceData?.invoicetaxabletypecd == 1 || invoiceData?.invoicetaxabletypecd == 4 || invoiceData?.invoicetaxabletypecd == 6
            ? itm.gstrate
            : 0;
        return {
          SlNo: (i + 1).toString(),
          PrdDesc: itm.invoicelineitemtype === 'ITEM' ? itm.relateditemmaster[0].itemname : itm.relatedaccounts[0].accountname,
          IsServc: itm.invoicelineitemtype === 'ITEM' ? (itm.relateditemmaster[0].itemtype === 'GOODS' ? 'N' : 'Y') : 'Y',
          HsnCd: itm.hsnsaccode.toString(),
          Qty: itm.quantity ? itm.quantity : 0,
          Unit: itm.unit ? itm.unit : 'OTH',
          UnitPrice: itm.itemrate ? Number(itm.itemrate.toFixed(2)) : Number(itm.taxableamount.toFixed(2)),
          TotAmt: itm.invoicelineitemtype === 'ITEM' ? Number(itm.itemamount.toFixed(2)) : Number(itm.taxableamount.toFixed(2)),
          Discount: itm.itemdiscount ? Number(itm.itemdiscount.toFixed(2)) : 0,
          AssAmt:
            itm.invoicelineitemtype === 'ITEM'
              ? Number((Number(itm.itemamount.toFixed(2)) - Number(itm.itemdiscount.toFixed(2))).toFixed(2))
              : Number(itm.taxableamount.toFixed(2)),
          GstRt: gstRate,
          IgstAmt: gst === 'i' ? gstAmt : 0,
          CgstAmt: gst === 'c' ? gstAmt / 2 : 0,
          SgstAmt: gst === 'c' ? gstAmt / 2 : 0,
          // CesRt: ,
          CesNonAdvlAmt: Number(itm.cessamount.toFixed(2)),
          OthChrg: 0,
          TotItemVal:
            itm.invoicelineitemtype === 'ITEM'
              ? Number(
                  (
                    Number(itm.itemamount.toFixed(2)) -
                    Number(itm.itemdiscount.toFixed(2)) +
                    (invoiceData.reversechargeflag === 1 ? Number(0) : Number(gstAmt.toFixed(2))) +
                    (invoiceData.reversechargeflag === 1 ? Number(0) : Number(itm.cessamount.toFixed(2)))
                  ).toFixed(2)
                )
              : Number(
                  (
                    Number(itm.taxableamount.toFixed(2)) +
                    (invoiceData.reversechargeflag === 1 ? Number(0) : Number(gstAmt.toFixed(2))) +
                    (invoiceData.reversechargeflag === 1 ? Number(0) : Number(itm.cessamount.toFixed(2)))
                  ).toFixed(2)
                ),
          PrdSlNo: itm.invoicelineitemtype === 'ITEM' ? itm.itemid.toString() : itm.incomeaccountid.toString(), //itemcode
        };
      });
    const totInvDat =
      lineData &&
      lineData.length > 0 &&
      lineData.reduce(
        (acc, itm) => {
          const gst = invoiceData.companystate === invoiceData.placeofsupply ? 'c' : 'i';
          const gstAmt = 0 + Number(itm.gstamount);
          const assVal = itm.invoicelineitemtype === 'ITEM' ? itm.itemamount - itm.itemdiscount + 0 : itm.taxableamount + 0;
          const cessVal = 0 + itm.cessamount;
          const othChrg = invoiceData.relatedinvoicetcsdetails[0].tcsamount;

          acc.AssVal += assVal;
          acc.IgstVal += gst === 'i' ? gstAmt : 0;
          acc.CgstVal += gst === 'c' ? gstAmt / 2 : 0;
          acc.SgstVal += gst === 'c' ? gstAmt / 2 : 0;
          acc.CesVal += cessVal;
          acc.Discount = invoiceData.relatedinvoicetcsdetails[0].adjustmentamount;
          acc.OthChrg = invoiceData.relatedinvoicetcsdetails[0].tcsamount;
          acc.RndOffAmt = invoiceData.roundoffamount;
          acc.TotInvVal =
            acc.AssVal -
            invoiceData.relatedinvoicetcsdetails[0].adjustmentamount +
            (invoiceData.reversechargeflag === 1
              ? (acc.IgstVal + acc.CgstVal + acc.SgstVal) * 0
              : (acc.IgstVal + acc.CgstVal + acc.SgstVal) * 1) +
            (invoiceData.reversechargeflag === 1 ? 0 : acc.CesVal) +
            invoiceData.relatedinvoicetcsdetails[0].tcsamount +
            invoiceData.roundoffamount;

          return acc;
        },
        {
          AssVal: 0,
          IgstVal: 0,
          CgstVal: 0,
          SgstVal: 0,
          CesVal: 0,
          Discount: 0,
          OthChrg: 0,
          RndOffAmt: 0,
          TotInvVal: 0,
        }
      );
    const total = async () => {
      Object.keys(totInvDat).forEach((key) => {
        totInvDat[key] = parseFloat(totInvDat[key].toFixed(2));
      });
      return totInvDat;
    };
    // .then((result) => {
    //   // Apply final rounding at the very end
    //   Object.keys(result).forEach((key) => {
    //     result[key] = parseFloat(result[key].toFixed(2));
    //   });
    //   console.log(result);
    //   return result;
    // });

    const generateEInv = async (id) => {
      setIErr('');
      console.log(id, 'iiiiii');
      const maxLength = 85; // Maximum allowed length

      // Sample data from the company object
      let address_sell = getCompany.line1;

      if (address_sell.length > maxLength) {
        // Find the last space within the maxLength limit
        const truncated = address_sell.slice(0, maxLength);
        const lastSpaceIndex = truncated.lastIndexOf(' ');

        // If there's a space within the truncated portion, trim there
        if (lastSpaceIndex > -1) {
          address_sell = truncated.substring(0, lastSpaceIndex) + '...';
        } else {
          address_sell = truncated + '...'; // If no space is found, just truncate and add '...'
        }
      }
      let address_buy = billing?.line1;

      if (address_buy?.length > maxLength) {
        // Find the last space within the maxLength limit
        const truncated = address_buy.slice(0, maxLength);
        const lastSpaceIndex = truncated.lastIndexOf(' ');

        // If there's a space within the truncated portion, trim there
        if (lastSpaceIndex > -1) {
          address_buy = truncated.substring(0, lastSpaceIndex) + '...';
        } else {
          address_buy = truncated + '...'; // If no space is found, just truncate and add '...'
        }
      }
      const totData = await total();
      let payload = {
        action: 'generateIrn',
        version: '1.0',
        data: {
          Version: '1.1',
          TranDtls: {
            TaxSch: 'GST',
            SupTyp:
              invoiceData.invoicetaxabletypecd == 6
                ? 'SEZWP'
                : invoiceData.invoicetaxabletypecd == 7
                ? 'SEZWOP'
                : invoiceData.invoicetaxabletypecd == 8
                ? 'EXPWP'
                : invoiceData.invoicetaxabletypecd == 9
                ? 'EXPWOP'
                : 'B2B',
            RegRev:
              data[0].placeofsupply == '96'
                ? 'N'
                : invoiceData.reversechargeflag === 1 || getCompany?.statecode == data[0]?.companystate
                ? 'Y'
                : 'N',
            EcmGstin: null,
            IgstOnIntra:
              invoiceData.relatedpartymaster[0].gstcategory === 'SEZ' || getCompany.relatedcompanydetailsnew[0].registrationtype == 4
                ? 'Y'
                : 'N',
          },
          DocDtls: {
            Typ: 'INV',
            No: data[0].invoicenumber,
            Dt: moment(data[0].invoicedate * 1000).format('DD/MM/YYYY'),
          },
          SellerDtls: {
            // Gstin: "07AGAPA5363L002",
            Gstin: getCompany.relatedcompanyentity[0].gstin,
            LglNm: getCompany.companyname,
            TrdNm: getCompany.relatedcompanydetailsnew[0].companyshort,
            Addr1: address_sell,
            // Addr2: "",
            Loc: getCompany?.city,
            // Pin: 110055,
            Pin: getCompany.relatedaddressentity[0].pincode,
            // Stcd: "07",
            Stcd: getCompany.relatedaddressentity[0].statecode,
            // Ph: "9895765268",
            // Em: getCompany.relatedEmailContacts[0].EmailAddress,
          },
          BuyerDtls: {
            Gstin: data[0].placeofsupply == '96' ? 'URP' : data[0].relatedpartymaster[0].relatedpartygstdetails[0]?.gstin,
            LglNm: data[0].relatedpartymaster[0]?.partylegalname,
            TrdNm: data[0].relatedpartymaster[0]?.partydisplayname,
            Pos: data[0].placeofsupply,
            Addr1: address_buy,
            // Addr2: "",
            Loc: billing?.city,
            Pin: data[0].placeofsupply == '96' || data[0].placeofsupply == '97' ? '999999' : billing.pincode,
            Stcd: data[0].placeofsupply,
            // Ph:
            //   data[0].RelatedPartyMaster[0]?.relatedPartyContact[0]?.PhoneNumber ||
            //   "9895789789",
            // Em:
            //   data[0].RelatedPartyMaster[0]?.relatedPartyContact[0]?.Email ||
            //   "abc@gmail.com",
          },
          ItemList: invDat,
          ValDtls: totData,
          PayDtls: {
            // Nm: "ABCDE",
            // AccDet: "5697389713210",
            Mode: invoiceData.paymenttype === 'Cash' || invoiceData.paymenttype === 'Credit' ? invoiceData.paymenttype : 'Direct Transfer',
            PaidAmt: Number(invoiceData.receivedamount.toFixed(2)),
            PaymtDue: Number(Number(invoiceData.invoiceamount).toFixed(2) - Number(invoiceData.receivedamount).toFixed(2)).toFixed(2),
          },
          RefDtls: {
            InvRm: 'TEST',
            PrecDocDtls: [
              {
                InvNo: data[0].invoicenumber,
                InvDt: moment(data[0].invoicedate * 1000).format('DD/MM/YYYY'),
              },
            ],
          },
          // ExpDtls: {
          // ShipBNo: "A-248",
          // ShipBDt: "01/08/2020",
          // Port: "INABG1",
          // RefClm: "N",
          // ForCur: "AED",
          // CntCode: 'AE',
          // ExpDuty: null
          // },
          AddlDocDtls: [
            {
              Url: 'https://einv-apisandbox.nic.in',
              Docs: 'Test Doc',
              Info: 'Document Test',
            },
          ],
        },
        InvoiceID: id,
        credentials: prevData,
      };
      setBackdropOpen(true);
      try {
        const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EINVOICE_URL, payload);
        const IRN = res.data.Irn;
        showSuccessSnackbar('E-invoice successfully generated');
        createPdf({
          path: path + `Invoices/Sales/Ledgerx_Sales_Invoice_${data[0].invoicenumber}.pdf`,
          type: 'salesInvoice',
          invoiceids: id,
        });
        if (loc === '/salesInvoiceReport') {
          allsalesfn(id, IRN);
        }
        if ((saveNew === false || saveNew === undefined) && eWayImp === false) {
          await setOpen(false);
          navigate('/salesInvoiceReport', {
            state: { id },
          });
        } else if (eWayImp === true) {
          dispatch(einvAuthData({}));
          return;
        } else {
          console.log(open, 'opennnn');
          await setInvID('');
          await setEImp(false);
          await setOpen(false);
          setInvData((prev) => ({
            ...resetData,
            invoiceDate: prev?.invoiceDate,
            customerOrderDate: prev?.customerOrderDate,
          }));

          // getVoucherDetails("Receipt");
          getLastSalesInvoice();
          dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'SalesInvoice' }]));
          dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
          setNonItems([resetNonItems]);
          setItems([resetItems]);
          setItemValid(true);
          setNonItemValid(true);
          setItemsRows([]);

          navigate('/addnewinvoicetax');
        }
        dispatch(einvAuthData({}));
        dispatch(einvAuth(false));
        dispatch(einvPreview({ preview: false, id: 0 }));
        dispatch(einvId(false));
        setBackdropOpen(false);
      } catch (error) {
        console.log(error, 'error');
        if (error.response.status === 403) {
          showWarningSnackbar('Invalid Credentials');
          dispatch(einvPreview({ preview: false, id: 0 }));
          dispatch(einvAuth(true));
        } else {
          console.log(error, 'error.response.data');
          if (error.response.status >= 500) {
            showWarningSnackbar('Internal Server Error');
            navigate('/salesInvoiceReport');
          }
          const errorMessage = error.response.data.details.ErrorDetails[0]?.ErrorMessage;
          console.log(errorMessage, 'errorMessage');
          // if (loc === "/addnewinvoicetax") {
          navigate('/editnewinvoicetax', {
            state: { id, eImp: true },
          });
          // }
          setTimeout(() => {
            showWarningSnackbar(errorMessage);
          }, 100);
          dispatch(einvPreview({ preview: true, id: 0 }));
        }
      } finally {
        setBackdropOpen(false);
      }
    };
    const handlePrint = () => {
      setOpen(false);
      printJS({
        printable: html,
        type: 'raw-html',
        documentTitle: 'Sales Invoice',
      });
    };
    const themess = createTheme({
      palette: {
        mode: 'light',
      },
    });
    useImperativeHandle(ref, () => ({
      triggerCustomAction: getInvoiceMasterData,
    }));
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        sx={style}
      >
        <Modal.Header>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                Preview
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <Fade in={open}>
            <Box
              className={'custom-scrollbar'}
              sx={{
                // margin: "auto",
                padding: '30px',
                marginBottom: '15px',
                paddingBottom: '15px',
                width: '90%',
                // display : "flex",
                // flexDirection : "row"
                height: {
                  xs: '500px',
                  sm: type === 'receipt' || type === 'payment' ? '45vh' : '80vh',
                },

                // overflowY: { xs: "auto" },
                // width: { xs: "90%", lg: "90%" },
                transform: { xs: 'scale(0.7)', sm: 'scale(1)' },
                // transformOrigin: "right",
                // overflow:"scroll"
              }}
            >
              <ThemeProvider theme={themess}>
                <div className="render" style={{ paddingBottom: '20px', minWidth: '1000px' }} dangerouslySetInnerHTML={{ __html: html }} />
              </ThemeProvider>
            </Box>
          </Fade>
        </Modal.Body>

        <Modal.Footer>
          <Box
            sx={{
              // position: 'sticky', bottom: 0, left: 0,
              bgcolor: 'background.paper',
              padding: '10px 15px',

              margin: 'auto',
              display: 'flex',
              justifyContent: 'flex-end',
              // position:"absolute",
              // bottom:0
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                fontSize: '12px',
                marginBottom: { xs: '20px', md: '0px' },
                marginLeft: { xs: '0px', sm: '20px' },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>
    );
  }
);

export default PreviewSalesTaxable;
